"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M26 22.086V11a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12.586a1 1 0 0 0 .293.707l6.3 6.3a1 1 0 0 0 1.414 0l1.336-1.336a1 1 0 0 0 0-1.414l-5.054-5.054a1 1 0 0 1-.289-.703z" }),
  React.createElement("path", { d: "M24 7.8A16.2 16.2 0 1 1 7.8 24 16.219 16.219 0 0 1 24 7.8zM24 4a20 20 0 1 0 20 20A20 20 0 0 0 24 4z" })
);

